import { jsx as _jsx } from "react/jsx-runtime";
import { faLockKeyhole } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { css } from "styled-components";
import { defaultButtonType } from "../button";
const _LockedBadge = ({ type = defaultButtonType, disabled, ...props }) => {
    return (_jsx(Wrapper, { ...props, "$type": type, "$disabled": disabled, children: _jsx(FontAwesomeIcon, { icon: faLockKeyhole }) }));
};
const lockedBadgeThemes = {
    primary: css `
    color: ${(p) => p.theme.systemColors.blue600};
    background-color: ${(p) => p.theme.systemColors.white};
  `,
    secondary: css `
    color: ${(p) => p.theme.systemColors.white};
    background-color: ${(p) => p.theme.systemColors.blue600};
  `,
    tertiary: css `
    color: ${(p) => p.theme.systemColors.white};
    background-color: ${(p) => p.theme.systemColors.grey400};
  `,
    text: css `
    color: ${(p) => p.theme.systemColors.blue600};
    background-color: ${(p) => p.theme.systemColors.white};
  `,
    icon: css `
    color: ${(p) => p.theme.systemColors.grey600};
    background-color: transparent;
  `,
    cancel: css `
    color: ${(p) => p.theme.systemColors.black};
    background-color: transparent;
  `,
};
const Wrapper = styled.div `
  width: 22px;
  height: 22px;
  border-radius: 22px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color 0.2s ease,
    color 0.2s ease;

  ${(p) => lockedBadgeThemes[p.$type]}

  ${(p) => p.$disabled &&
    css `
      color: ${(p) => p.theme.systemColors.white};
      background-color: ${(p) => p.theme.systemColors.grey300};
    `}
`;
export const LockedBadge = Object.assign(_LockedBadge, {
    Wrapper,
});
